/** GET /agenthome/me/stats — the caller's own session + time-saved stats.
 *
 * One "session" = a qualified agent-session (at least one successful agent
 * response; abandoned chats never count), credited once ever with the agent's
 * owner-configured time-saved-per-session minutes, valued at the rate in
 * force on the session's date. Same facts the admin ROI dashboard reads.
 */

export interface StatsWindow {
  sessions: number;
  time_saved_minutes: number;
}

export interface StatsAgentRow {
  agent_id: string;
  display_name: string;
  department: string;
  sessions: number;
  time_saved_minutes: number;
}

export interface StatsDayBucket {
  day: string; // YYYY-MM-DD (UTC)
  sessions: number;
  time_saved_minutes: number;
}

export interface StatsSummary {
  total: StatsWindow;
  this_month: StatsWindow;
  by_agent_top: StatsAgentRow[];
  /** Last 30 UTC days, zero-filled, oldest first — sparkline data. Optional:
   *  older API versions don't send it (widget simply hides the sparkline). */
  by_day?: StatsDayBucket[];
  /** Agents whose sessions counted but have no configured time-saved value. */
  unclassified_agent_ids: string[];
  include_runs: boolean;
  as_of: string;
}

/** "6h 30m" / "45m" / "0m" — hours+minutes, never fractional hours. */
export function formatMinutes(minutes: number): string {
  const m = Math.max(0, Math.round(minutes || 0));
  const h = Math.floor(m / 60);
  const rest = m % 60;
  if (h === 0) return `${rest}m`;
  return rest === 0 ? `${h}h` : `${h}h ${rest}m`;
}
